(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("sw-hic"));
	else if(typeof define === 'function' && define.amd)
		define(["sw-hic"], factory);
	else if(typeof exports === 'object')
		exports["patient"] = factory(require("sw-hic"));
	else
		root["patient"] = factory(root["sw-hic"]);
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__511__) => {
return 